import CrmDashboardAPI from '../../api/saas/crmDashboard';

const state = {
  report: null,
  uiFlags: {
    isFetching: false,
    hasError: false,
  },
};

const getters = {
  getReport($state) {
    return $state.report;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

const actions = {
  async get({ commit }, params = {}) {
    commit('SET_CRM_DASHBOARD_UI_FLAG', { isFetching: true, hasError: false });
    try {
      const response = await CrmDashboardAPI.get(params);
      commit('SET_CRM_DASHBOARD_REPORT', response.data);
      return response.data;
    } catch (error) {
      commit('SET_CRM_DASHBOARD_UI_FLAG', { hasError: true });
      throw error;
    } finally {
      commit('SET_CRM_DASHBOARD_UI_FLAG', { isFetching: false });
    }
  },
};

const mutations = {
  SET_CRM_DASHBOARD_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  SET_CRM_DASHBOARD_REPORT($state, data) {
    $state.report = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
